import ColorPicker from 'simple-color-picker';

import Base from 'app/views/base';

import tmpl from 'templates/color_picker';

export default Base.extend({
  compiledTemplate: tmpl,

  events: {
    'focus input': 'showColorPicker',
    'click .input-group-addon': 'focusInput',
    'blur input': 'hideColorPicker',
    'keyup input': 'setColorPreview',
  },

  afterRender() {
    this.setColorPreview();
  },

  context() {
    return {
      color: this.model.escape('color'),
    };
  },

  showColorPicker(e) {
    const inputField = this.$(e.target);
    const inputGroup = inputField.parent();
    const colorPicker = new ColorPicker({
      el: inputGroup.parent().get(0),
      color: inputField.val(),
      background: '#FFFFFF',
      height: '200',
      width: '250',
    });
    colorPicker.onChange((color) => {
      this.model.set('color', color.toUpperCase(), { silent: true });
      inputField.val(color.toUpperCase());
      this.setColorPreview();
    });
  },

  focusInput() {
    this.$('input').focus();
  },

  setColorPreview(e) {
    if (e) this.model.set('color', this.$(e.target).val());
    this.$('.color-preview').css('background-color', this.model.escape('color'));
  },

  hideColorPicker() {
    this.$('.Scp').remove();
  },
});



// WEBPACK FOOTER //
// ./app/views/color_picker_view.js